import {Item} from '../../generated/types';
import {humanNumber} from '../utils';
import {ItemRarityNames} from './item-rarity-names';

export function getItemPrice(item: Item, isLegacy = false) {
	if (item.price)
		return (
			<p>
				<b>Цена</b> {itemPriceToString(item.price)}
			</p>
		);

	const rarity = ItemRarityNames[item.rarity];

	if (isLegacy) {
		if (rarity?.legacyPriceMin) {
			const range = rarity.legacyPriceMax
				? `${humanNumber(rarity.legacyPriceMin)}–${humanNumber(rarity.legacyPriceMax)} ЗМ`
				: `от ${humanNumber(rarity.legacyPriceMin)} ЗМ`;
			const dice = rarity.legacyPriceDice ? ` (бросок: ${rarity.legacyPriceDice} ЗМ)` : '';
			return (
				<p>
					<b>Цена</b> {range}{dice}
				</p>
			);
		}
		return null;
	}

	if (rarity?.price) {
		let price = rarity.price;
		let approximate = false;
		if (item.baseItem?.price) price += item.baseItem.price;
		else approximate = true;
		return (
			<p>
				<b>Цена</b> {itemPriceToString(price * 100)}
				{approximate ? ` + стоимость базового предмета` : ''}
			</p>
		);
	}

	return null;
}

function itemPriceToString(priceInCc: number) {
	if (priceInCc > 100) return `${humanNumber(priceInCc / 100)} ЗМ`;
	else if (priceInCc > 10) return `${humanNumber(priceInCc / 10)} СМ`;
	else return `${humanNumber(priceInCc)} ММ`;
}
